import apis from './apis';

const svg = encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="800"><rect width="100%" height="100%" fill="#eef2f7"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="34" fill="#667085">No Image</text></svg>`);
export const MEDIA_PLACEHOLDER = `data:image/svg+xml;charset=UTF-8,${svg}`;

export const resolveMedia = (value) => {
  const src = String(value || '').trim();
  if (!src) return MEDIA_PLACEHOLDER;
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  return `${apis().localUrl}${src.replace(/^\//, '')}`;
};
